<!-- App layout container -->
<app-layout>
  <app-toolbar class="w-full" />

  <app-sidebar />

  <app-map-2 [listings]="listingsService.filteredListings()" />
</app-layout>

<!-- Contact FAB -->
@defer {
  <app-contact-fab />
}

<!-- Modals -->
@defer {
  <app-modals class="absolute top-0" />
}
